<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

            <!-- <label>商品名称:</label>
            <lk-input clearable placeholder="请输入" v-model='query.approvedDrugName' class="item"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>采购订单号:</label>
            <lk-input clearable placeholder="请输入" v-model='query.code' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <!-- <div class="queryItem">
            <label>商品编码:</label>
            <lk-input clearable placeholder="请输入" v-model='query.drugSerialCode' class="item"></lk-input>
          </div> -->
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect v-model="query.supplierId"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import expandRow from './table-expand.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'waitingReceipt',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, SupplierListSelect,
  },
  computed: {
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  data() {
    return {
      showReceipt: false,
      paymentType: ['普通', '寄售'],
      query: {
        code: '',
        supplierName: '',
        supplierCode: '',
        approvedDrugName: '',
        drugSerialCode: '',
        supplierId: null,
        goodsType: null, // 商品类型
        purchaseType: null, // 来源
      },
      unqualifiedTypes: [{
        id: 1,
        name: '药品过期',
      }, {
        id: 2,
        name: '药监抽检',
      }, {
        id: 3,
        name: '药品损坏',
      }],
      columns: [
        {
          type: 'expand',
          width: 46,
          render: (h, params) => h(expandRow, {
            props: {
              row: params.row,
              goodsType: params.row.purchaseOrderGoodsType,
            },
          }),
        },
        {
          title: '采购订单号',
          key: 'purchaseOrderCode',
          minWidth: 116,
        },
        {
          title: '商品类型', key: 'purchaseOrderGoodsTypeName', width: 116,
        },
        {
          title: '来源', key: 'purchaseOrderPurchaseTypeName', width: 116,
        },
        {
          title: '供应商',
          key: 'purchaseOrderSupplierName',
          minWidth: 116,
        },
        {
          title: '成本类型',
          key: 'purchaseOrderPayment',
          minWidth: 116,
        },
        {
          title: '订单状态',
          key: 'purchaseOrderStatusName',
          minWidth: 116,
        },
        {
          title: '创建人',
          key: 'purchaseOrderCreateUserName',
          minWidth: 116,
        },
        {
          title: '创建时间',
          key: 'purchaseOrderCreateTime',
          minWidth: 116,
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { row }) => {
            let disabled = false;
            if (!this.showReceipt) {
              disabled = true;
            }
            return h(
              'lk-button',
              {
                props: {
                  type: 'text',
                  size: 'small',
                  disabled,
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'doReceipt',
                      params: { purchaseOrderId: row.purchaseOrderId },
                    });
                  },
                },
              },
              '生成收货单',
            );
          },

        },
      ],
      tableData: [],
    };
  },
  methods: {
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      purchase.receiptManage(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            const purchaseMedicineInfoVoList = [];
            utils.exchangeTable(item, result);
            result.purchaseOrderPayment = this.paymentType[result.purchaseOrderPayment - 1];
            if (result.purchaseOrderCreateTime) {
              result.purchaseOrderCreateTime = utils.formatTime(result.purchaseOrderCreateTime, 'YYYY/MM/DD HH:mm');
            }

            utils.exchangeTable();
            result.purchaseMedicineInfoVoList.forEach((infoItem) => {
              const tempResult = {};
              utils.exchangeTable(infoItem, tempResult);
              purchaseMedicineInfoVoList.push(tempResult);
            });
            result.purchaseMedicineInfoVoList = purchaseMedicineInfoVoList;
            // console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        inventoryIds: [],
        nameMix: '',
      };
    },
  },
  created() {
    // this.getData();
    this.handleSearch(true);
    // this.getSuppliers();
    if (this.handlePermission('doReceipt')) {
      this.showReceipt = true;
    }
  },
};
</script>
<style lang="less" scoped>
</style>
